module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Saúde Quatro Patas")]), _vm._v(" "), _c('h5', [_vm._v("Esqueci minha senha")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Informe seu e-mail para resetar a senha")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3",
    class: {
      'has-danger': _vm.$v.user.email.$error
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "E-mail",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }, function($event) {
        _vm.$v.user.email.$touch()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link px-0",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancelar")])])])])])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enviar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-inverse py-5 d-md-down-none",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('div', {
    staticClass: "card-block text-center"
  }, [_c('div', [_c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "Dowhile",
      "width": "240"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('small', [_c('span', [_vm._v("Desenvolvido por "), _c('a', {
    attrs: {
      "href": "https://dowhile.com.br/",
      "target": "_blank"
    }
  }, [_vm._v("Dowhile")]), _vm._v(" © 2019.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc0f1470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ForgotPassword.vue
// module id = 903
// module chunks = 1